'use strict';

import IScroll from 'iscroll';

/**
 * Custom select for forms
 */

let customSelect = {

    activeClass: 'custom-select--active',

    init: function() {
        let self = this;

        this.csSelect = document.querySelectorAll('.custom-select');

        Array.from(this.csSelect, el => {
            this.initSelect(el);
        });

        // Close each custom select if user clicks outside
        $(document).on('click', event => {
            if (!$(event.target).closest('.custom-select').length) {
                Array.from(this.csSelect, el => {
                    el.classList.remove(this.activeClass);
                });
            }
        });

        // When clicking a .custom-select element, close all other but the targeted one
        $(this.csSelect).on('click', function() {
            if ($(self.csSelect).not($(this)).hasClass('custom-select--active')) {
                $(self.csSelect).not($(this)).removeClass('custom-select--active');
            }
        });
    },

    /**
     * Add dynamically a new dropdown list and initialize it
     * @param el The dropdown list
     */
    addSelect: function(el) {
        this.csSelect = document.querySelectorAll('.custom-select');
        this.initSelect(el);
    },

    /**
     * Initialize each dropdown
     *
     * @param el
     */
    initSelect: function(el) {
        const select = el.querySelector('select');
        const placeHolder = el.querySelector('.custom-select__placeholder');
        const selectOptions = el.querySelector('.custom-select__option-list');
        const dataProvider = el.getAttribute('data-provider');
        const isCheckboxList = el.getAttribute('data-checkbox-list');

        if (el.classList.contains('custom-select--initialized')) {
            return;
        }

        // If there is a dataProvider and it's a select tag, it will fill the custom select with its data
        if (dataProvider === 'select') {
            this.fillCustomSelect(selectOptions, select);

            // Update the placeholder text with the selected value of the <select> tag
            placeHolder.textContent = this.getSelectedValue(select).text;
            // this.storeIndex(el, select.options.selectedIndex);
            this.storeValue(el, select.options[select.options.selectedIndex].value);
        }

        // Open/close the custom select when user click on placeholder or list items
        el.addEventListener('click', e => {
            // On checkbox list, close dropdown list only when click on placeholder
            if (isCheckboxList && !e.target.classList.contains('custom-select__placeholder')) {
                return;
            }

            this.toggleSelect(el);

            if (dataProvider === 'select') {
                // Click on list items
                if (e.target.classList.contains('custom-select__option')) {
                    placeHolder.textContent = e.target.textContent;
                    select.value = e.target.getAttribute('data-value');

                    this.storeValue(el, e.target.getAttribute('data-value'));
                }
            }
        });

        let iScrollOptions = {
            mouseWheel: true,
            scrollbars: 'custom',
            click: true,
            interactiveScrollbars: true,
            disablePointer: true,
            disableTouch: false,
            disableMouse: false
        };

        if (isCheckboxList) {
            // If there is a checkbox list, these options allow user to check checkboxes
            Object.assign(iScrollOptions, {
                click: false,
                preventDefaultException: {
                    tagName:/.*/
                }
            });

            // Update the placeholder with the labels of checked checkbox
            Array.from(el.querySelectorAll('input[type=checkbox]'), checkbox => {
                const label = el.querySelector(`label[for=${checkbox.id}]`);

                // Store label text
                checkbox.setAttribute('data-label', label.innerText);

                checkbox.addEventListener('change', (e) => {
                    this.updatePlaceholderWithCheckboxes(el, e);
                });
            });

            this.updatePlaceholderWithCheckboxes(el);
        }

        // Initialize iScroll plugin with the wrapper
        let optionsScroll = new IScroll(el.querySelector('.custom-select__options'), iScrollOptions);

        // Store the iScroll instance in a jQuery object attached to the element
        $(el).data('iscroll', optionsScroll);

        // The dropdown list has been initialized
        el.classList.add('custom-select--initialized');
    },

    /**
     * Fill the custom dropdown with the <select> datas
     *
     * @param selectOptions
     * @param select
     */
    fillCustomSelect: function(selectOptions, select) {
        for (const option of Array.from(select.options)) {
            // Don't add option with empty value
            if (option.value === '') {
                continue;
            }

            let child = document.createElement('li');
            child.classList.add('custom-select__option');
            child.setAttribute('data-value', option.value);
            child.textContent = option.text;

            selectOptions.appendChild(child);
        }
    },

    /**
     * Get the selected option information from the <select> tag
     *
     * @param select
     * @returns {{value: (string|*), text: *}}
     */
    getSelectedValue: function(select) {
        return {
            value: select.value,
            text: select.options[select.selectedIndex || 0].text
        };
    },

    /**
     * Open/close the dropdown list
     * @param el
     */
    toggleSelect: function(el) {
        el.classList.toggle(this.activeClass);

        // If we open the dropdown, we refresh iScroll to redefine scroll/size values
        if (el.classList.contains(this.activeClass)) {
            setTimeout(function () {
                let is = $(el).data('iscroll');
                is.refresh();

                this.showHideScrollbar(el, is);

                // Scroll to the selected value
                const currentValue = el.getAttribute('data-value');
                const target = el.querySelector(`.custom-select__option[data-value="${currentValue}"]`);
                if (target) {
                    is.scrollToElement(target, 0);
                }
            }.bind(this), 0);
        }
    },

    /**
     * Hide vertical scrollbar when vertical scrollbar is disabled
     *
     * @param el dropdown
     * @param isInstance iScroll instance
     */
    showHideScrollbar: function(el, isInstance) {
        if (isInstance.hasVerticalScroll) {
            el.querySelector('.iScrollVerticalScrollbar').classList.remove('inactive');
        } else {
            el.querySelector('.iScrollVerticalScrollbar').classList.add('inactive');
        }
    },

    storeIndex: function(select, index) {
        select.setAttribute('data-index', index);
    },

    storeValue: function(select, value) {
        select.setAttribute('data-value', value);
    },

    /**
     * Get the node index
     *
     * @param el
     * @returns {number}
     */
    getNodeindex: function(el) {
        return [...el.parentNode.children].indexOf(el);
    },

    /**
     * Update the placeholder with the checked checbox
     *
     * @param el Custom dropdown list
     */
    updatePlaceholderWithCheckboxes: function(el, e) {
        // debugger;
        if (e === undefined) {
            e = null;
        }

        let inputCheckedList  = el.querySelectorAll('input[type=checkbox]:checked'),
            //outputCheckedList = null,
            placeholder       = el.querySelector('.custom-select__placeholder'),
            labels            = [];
            //changeInput       = false;

        /*Array.from(inputCheckedList, (item, index) => {
            item.checked = false;
            changeInput = true;
        });*/

        //let inputCheckedLists  = el.querySelectorAll('input[type=checkbox]:checked');
        //window.console.log('inputCheckedLists ', inputCheckedLists);
        //return false;
        /*if (e !== null) {
            if (e.target.id && changeInput) {
                e.target.checked = true;
                outputCheckedList = el.querySelectorAll('input[type=checkbox]:checked');
            } else {
                e.target.checked = false;
                outputCheckedList = [];
            }
        }*/

        if (inputCheckedList !== null && inputCheckedList.length) {
            Array.from(inputCheckedList, checkbox => {
                labels.push(checkbox.getAttribute('data-label'));
            });

            placeholder.innerText = labels.join(', ');
        } else {
            placeholder.innerText = placeholder.getAttribute('data-default-text');
        }
    }

};

export default customSelect;


// WEBPACK FOOTER //
// ./src/js/components/custom-select.js